module.exports = __webpack_public_path__ + "img/news_banner.f9e83164.jpg";